import { __exports as e } from "../../../_virtual/object-get-own-property-names.js";
import { o as t } from "./object-keys-internal.js";
import { e as o } from "./enum-bug-keys.js";
var r = o.concat("length", "prototype");
e.f = Object.getOwnPropertyNames || function (e) {
  return t(e, r);
};
export { e as default };